import { string, func, oneOfType, number } from 'prop-types';

export default {
  image: string,
  name: string,
  guestRating: oneOfType([string, number]),
  guestRatingLabel: string,
  guestRatingCount: oneOfType([string, number]),
  tripAdvisorRatingUrl: string,
  onClickSelectRoom: func,
};
